export default async function resetErrorState(context) {
	context.dispatch('RESET_ERROR_STATE');
}
